module.exports = __webpack_public_path__ + "img/garansi-uang-kembali.6413e02b.svg";